<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="$route.params.id && !miapayWalletHolderId ? actions : []"
    :form="form"
    :onFetchData="onFetchData"
    :title="title || $t('model.walk/stepRecord')"
    resource="walk/step_records"
  >
    <template slot="page-top" v-if="type === 'index'">
      <div class="hint">{{ $t('hint.walkStepRecordIsActiveHint') }}</div>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../../admin_grapes/walk/step_records.js';

@Component
export default class WalkStepRecords extends Vue {
  @Prop(String) type;
  @Prop(String) title;
  @Prop(Number) miapayWalletHolderId;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      {
        prop: 'date_gteq',
        label: `${this.$t('walk/stepRecord.date')} ${this.$t('after')} `,
        renderCell: {
          component: 'datePicker',
          props: {
            valueFormat: 'yyyy-MM-dd'
          }
        }
      },
      {
        prop: 'date_lteq',
        label: `${this.$t('walk/stepRecord.date')} ${this.$t('before')} `,
        renderCell: {
          component: 'datePicker',
          props: {
            valueFormat: 'yyyy-MM-dd'
          }
        }
      },
      'device_id_cont',
      'is_active_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'date',
      'step',
      'device_id',
      'is_active',
      {
        prop: 'miapay_wallet_holder',
        label: this.$t('model.user'),
        renderCell: (h, { props: { value } }) => {
          if (value.user) {
            return <bean-link to={{ name: 'users.show', params: { id: value.user.id } }}>{this.$t('model.user')} {value.phone}</bean-link>
          }
        }
      },
      type === 'show' && {
        key: 'error_message',
        renderCell: (h, { props: { value, scope: { row } } }) => {
          if (value) {
            return <div>
              <div>{value}</div>
              {
                row.error_message_code === 'only_first_wallet_holder_of_the_same_device_is_active' ?
                  <bean-link to={{ name: 'users.show', params: { id: row.first_wallet_holder_of_the_same_device.user_id } }}>
                    {this.$t('hint.first_wallet_holder_of_the_same_device_hint')}: {row.first_wallet_holder_of_the_same_device.phone}
                  </bean-link> :
                  null
              }
            </div>
          }
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'walk/step_records.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'walk_step_records.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      let params = this.$route.query;
      if (this.miapayWalletHolderId) {
        params.miapay_wallet_holder_id_eq = this.miapayWalletHolderId;
      }
      const { data, pagination } = await this.$request.get('/walk/step_records', { params });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/walk/step_records/${this.$route.params.id}`);
      return { data };
    }

    if (type === 'new') {
      return {
        data: {}
      }
    }
  }
}

export const route = [
  {
    path: '/walk/step_records',
    name: 'walk/step_records.index',
    component: WalkStepRecords,
    props: {
      type: 'index',
    },
    mata: {
      can: 'walk_step_records.read'
    }
  },
  {
    path: '/walk/step_records/new',
    name: 'walk/step_records.new',
    component: WalkStepRecords,
    props: {
      type: 'new',
    },
    mata: {
      can: 'walk_step_records.create'
    }
  },
  {
    path: '/walk/step_records/:id',
    name: 'walk/step_records.show',
    component: WalkStepRecords,
    props: {
      type: 'show',
    },
    mata: {
      can: 'walk_step_records.read'
    }
  },
  {
    path: '/walk/step_records/:id/edit',
    name: 'walk/step_records.edit',
    component: WalkStepRecords,
    props: {
      type: 'edit'
    },
    mata: {
      can: 'walk_step_records.update'
    }
  }
]
</script>

<style lang="scss" scoped>
  /deep/.hint {
    margin: 10px 0 0 20px;
    color: #adadad;
  }
</style>
